import React, { useRef, useEffect, useMemo, useState } from 'react';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef, EmptyItem, RequiredRule, CustomRule } from "devextreme-react/form";
import Guid from "../../models/Guid";
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import useApi from '../../hooks/useApi';

interface IConfigurationMaterielProps {
    isModeSelection?: boolean,
}

interface ConfigurationMateriel {
    OUVRIR_TIROIR_CAISSE: boolean,
    IMPRIMANTE_EVOLIS_PORT: string,
    ACTIVER_SIGNATURE_TOPAZ: boolean,
    ACTIVER_BARRIERE_ATRIUM: boolean,
    ADRESSE_ATRIUM: string,
    ADRESSE_ATRIUM_LOCAL: string,
    UTILISATEUR_ATRIUM: string,
    MOT_PASSE_ATRIUM: string,
    HEURE_MAXIMUM_VALIDITÉ_ATRIUM: number,
    NOMBRE_HEURES_TAMPON_ATRIUM: number
}

export default function ConfigurationMateriel({isModeSelection}: IConfigurationMaterielProps) {
    const materielFormDataSource = useCustomDataSource<ConfigurationMateriel, ConfigurationMateriel>({path: "enregistrement", primaryKey: "idEnregistrementEntete"});
    const {setMainForm, selectedDataRow: selectedMateriel, setIsFieldModifier, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged} = materielFormDataSource;
    const formRef = useRef<FormRef>(null);

    const {
        getData: getConfig,
    } = useApi('Configuration');

    useEffect(() => {
        try {
            const names = 'OUVRIR_TIROIR_CAISSE,IMPRIMANTE_EVOLIS_PORT,ACTIVER_SIGNATURE_TOPAZ,ACTIVER_BARRIERE_ATRIUM,ADRESSE_ATRIUM,ADRESSE_ATRIUM_LOCAL,UTILISATEUR_ATRIUM,MOT_PASSE_ATRIUM,HEURE_MAXIMUM_VALIDITÉ_ATRIUM,NOMBRE_HEURES_TAMPON_ATRIUM'
            getConfig({customPath: `Configuration/${names}/Config`})
                .then((result) => {
                    setSelectedDataRow((prev: any) => {
                        if (!result || typeof result !== "object")
                            return prev;
                        return {...prev, ...result}
                    })
                })
                .catch((err) => console.log(err))
        } catch (error) {
        }
    }, [])

    const setDataRow = (e: string) => {
        setSelectedDataRow((prev: ConfigurationMateriel) => (
            {...prev, [e]: Guid.empty.toString()}
        ));
        setIsFieldModifier(true);
    }

    const portDefautEditorOption = useMemo(() => {
        return {
            disabled: !selectedMateriel.OUVRIR_TIROIR_CAISSE,
            dataSource: ["COM1"],
        }
    }, [selectedMateriel]);

    const typeCarteEditorOption = useMemo(() => {
        return {
            dataSource: ["26 bit", "test"], width: '200px'
        }
    }, []);

    const caractereEntreeDefautEditorOption = useMemo(() => {
        return {
            width: 175,
            dataSource: ["Aucun", "Tab", "Newline", "Enter", "Space"],
        }
    }, []);

  const editorOptions = useMemo(() => {
    return { maxLength: 112, width: '200px' };
  }, []);

    const spinOptions = useMemo(() => {
        return {min: 0, max: 999, showSpinButtons: true, width: '75px'}
    }, []);

    const adresseLocalEditorOptions = useMemo(() => {
        return {width: 200}
    }, []);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

  const heureValiditeEditorOptions = {
    width: '100px',
    mode: "text",
    mask: "00:00",
    maskRules: {
      H: /[0-2]/, // First digit of hours (0-2)
      h: (value: string) => {
        // Second digit of hours based on the first digit
        if (value[0] === "2") {
          return /[0-3]/; // Limit to 0-3 if the first digit is 2
        }
        return /[0-9]/; // Otherwise, allow 0-9
      },
      m: /[0-5]/, // First digit of minutes (0-5)
      M: /[0-9]/, // Second digit of minutes (0-9)
    },
    useMaskedValue: true, // Ensures value includes mask
    placeholder: "HH:MM",
  };
  const validationRules = [
    {
      type: "custom",
      message: "Enter a valid time between 00:00 and 23:59",
      validationCallback: (e: { value: string }) => {
        if (!e.value) return false; // Reject empty values
        const [hours, minutes] = e.value.split(":").map(Number); // Split into numbers
        return (
          hours >= 0 && hours <= 23 && // Hours must be valid
          minutes >= 0 && minutes <= 59 // Minutes must be valid
        );
      },
    },
    { type: "required", message: "This field is required" }, // Ensure input isn't empty
  ];

  console.log(selectedMateriel)
  return (
    <FormListBase data={materielFormDataSource} hideList={true}>
      {/* <FormListBaseGrid dataSource={materielFormDataSource.dataSource} onFocusedRowChanged={() => { setIsModeModify(false) }}      >
        <Column key={"grid-col-idEnregistrementEntete"} dataField={"idEnregistrementEntete"} caption="Description" allowHiding={false} />
      </FormListBaseGrid> */}
            <FormListBaseToolbar removeBlocked={true} headerText={``} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture
                ? <FormListBaseTab>
                    {/* <PopupGestionDepotsClients onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionDepots isModeSelection={true} />
          </PopupGestionDepotsClients> */}
                    <TabItem title="Général">
                        <div>
                            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedMateriel || {} as ConfigurationMateriel} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                                <GroupItem caption={"Tiroir caisses"} colCount={3}>
                                    <SimpleItem key={"frm-OUVRIR_TIROIR_CAISSE"} dataField={"OUVRIR_TIROIR_CAISSE"} editorType={"dxCheckBox"}>
                                        <Label text='Activer tiroir caisse'/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-IMPRIMANTE_EVOLIS_PORT"} dataField={"IMPRIMANTE_EVOLIS_PORT"} editorType={"dxSelectBox"} editorOptions={portDefautEditorOption}>
                                        <Label text={"Port"}/>
                                    </SimpleItem>
                                    <EmptyItem/>
                                </GroupItem>
                                <GroupItem caption={"Lecteur d'empreintes digitales"}>
                                    <SimpleItem key={"frm-empreintes"} dataField={"empreintes"} editorType={"dxCheckBox"}>
                                        <Label text="Activer le lecteur d'empreintes digitales (non installé)"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem caption={"Signatures électroniques"}>
                                    <SimpleItem key={"frm-ACTIVER_SIGNATURE_TOPAZ"} dataField={"ACTIVER_SIGNATURE_TOPAZ"} editorType={"dxCheckBox"}>
                                        <Label text="Activer la tablette de signature électronique Topaz"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem caption={"Lecteur RFID"}>
                                    <SimpleItem key={"frm-actif"} dataField={"activerTiroirCaisse"} editorType={"dxCheckBox"}>
                                        <Label text="Activer le lecteur RFID"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem caption={"Scanneurs UPC"} colSpan={3}>
                                    <SimpleItem key={"frm-caractere1"} dataField={"caractere1"} editorType={"dxSelectBox"} editorOptions={caractereEntreeDefautEditorOption}>
                                        <Label text={"Caractère d'entrée 1"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-caractere2"} dataField={"caractere2"} editorType={"dxSelectBox"} editorOptions={caractereEntreeDefautEditorOption}>
                                        <Label text={"Caractère d'entrée 2"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-caractere3"} dataField={"caractere3"} editorType={"dxSelectBox"} editorOptions={caractereEntreeDefautEditorOption}>
                                        <Label text={"Caractère de sortie"}/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem caption={"Barrière (Atrium)"}>
                                    <SimpleItem key={"frm-ACTIVER_BARRIERE_ATRIUM"} dataField={"ACTIVER_BARRIERE_ATRIUM"} editorType={"dxCheckBox"}>
                                        <Label text='Activer la gestion de barrière pour le poste actuel'/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-activerTiroirCaisse"} dataField={"activerTiroirCaisse"} editorType={"dxCheckBox"}>
                                        <Label text='Activer la gestion de barrière sur le web'/>
                                    </SimpleItem>
                                    <GroupItem colCount={2}>
                                        <SimpleItem key={"frm-ADRESSE_ATRIUM"} dataField={"ADRESSE_ATRIUM"}>
                                            <Label text="Adresse de l'interface"/>
                                        </SimpleItem>
                                        <SimpleItem key={"frm-ADRESSE_ATRIUM_LOCAL"} dataField={"ADRESSE_ATRIUM_LOCAL"} editorOptions={adresseLocalEditorOptions}>
                                            <Label text="Adresse locale de l'interface"/>
                                        </SimpleItem>
                                    </GroupItem>
                                    <SimpleItem key={"frm-UTILISATEUR_ATRIUM"} dataField={"UTILISATEUR_ATRIUM"} editorOptions={editorOptions}>
                                        <Label text="Utilisateur"/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-MOT_PASSE_ATRIUM"} dataField={"MOT_PASSE_ATRIUM"} editorOptions={editorOptions}>
                                        <Label text="Mot de passe"/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-HEURE_MAXIMUM_VALIDITÉ_ATRIUM"} dataField={"HEURE_MAXIMUM_VALIDITÉ_ATRIUM"} editorType='dxNumberBox' editorOptions={heureValiditeEditorOptions}>
                                        <Label text="Heure de validitié minimum"/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-NOMBRE_HEURES_TAMPON_ATRIUM"} dataField={"NOMBRE_HEURES_TAMPON_ATRIUM"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                                        <Label text={"Nombre d'heures tampon"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-typeCarte"} dataField={"typeCarte"} editorType={"dxSelectBox"} editorOptions={typeCarteEditorOption}>
                                        <Label text={"Type de carte"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </Form>
                        </div>
                    </TabItem>
                </FormListBaseTab> : null
            }
        </FormListBase>
    );
}